import { EventRow } from './logger.event-row';
import { loggerConstants } from 'app/logger/logger.constants';

export const ssisObjectMetadataDetailEvent = {
    RefreshStart: 'RefreshStart',
    RefreshFinish: 'RefreshFinish',
    RefreshDrop: 'RefreshDrop',
    ToResource: 'ToResource'
};

export const ssisObjectMetadataEventResult = {
    Succeeded: 'Succeeded',
    Failed: 'Failed'
};

export class SsisObjectMetadataEvent extends EventRow {

    public constructor(irName: string, detail: string, properties?: Record<string, unknown>) {
        super(loggerConstants.Event_SsisObjectMetadata, properties);
        this.addToProperties('irName', irName);
        this.addToProperties('detailEvent', detail);
    }
}
